import React from 'react';

const MoneyIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "33",
    height: "32",
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M26.2253 8.85333C25.652 5.96 23.5053 4.69333 20.5186 4.69333H8.81198C5.29198 4.69333 2.94531 6.45333 2.94531 10.56V17.4267C2.94531 20.3867 4.15865 22.12 6.15865 22.8667C6.45198 22.9733 6.77198 23.0667 7.10531 23.12C7.63865 23.24 8.21198 23.2933 8.81198 23.2933H20.532C24.052 23.2933 26.3986 21.5333 26.3986 17.4267V10.56C26.3986 9.93333 26.3453 9.37333 26.2253 8.85333ZM8.03865 16C8.03865 16.5467 7.58531 17 7.03865 17C6.49198 17 6.03865 16.5467 6.03865 16V12C6.03865 11.4533 6.49198 11 7.03865 11C7.58531 11 8.03865 11.4533 8.03865 12V16ZM14.6653 17.52C12.7186 17.52 11.1453 15.9467 11.1453 14C11.1453 12.0533 12.7186 10.48 14.6653 10.48C16.612 10.48 18.1853 12.0533 18.1853 14C18.1853 15.9467 16.612 17.52 14.6653 17.52ZM23.2786 16C23.2786 16.5467 22.8253 17 22.2786 17C21.732 17 21.2786 16.5467 21.2786 16V12C21.2786 11.4533 21.732 11 22.2786 11C22.8253 11 23.2786 11.4533 23.2786 12V16Z",
      fill: "#008500"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M30.399 14.56V21.4267C30.399 25.5333 28.0524 27.3067 24.519 27.3067H12.8124C11.8124 27.3067 10.919 27.16 10.1457 26.8667C9.51904 26.64 8.97237 26.3067 8.53237 25.88C8.29237 25.6533 8.47904 25.2933 8.81237 25.2933H20.519C25.4524 25.2933 28.3857 22.36 28.3857 17.44V10.56C28.3857 10.24 28.7457 10.04 28.9724 10.28C29.879 11.24 30.399 12.64 30.399 14.56Z",
      fill: "#008500"
    }
  )
);
MoneyIcon.displayName = "Icons.MoneyIcon";

export { MoneyIcon };
//# sourceMappingURL=MoneyIcon.js.map
